import type { AlienQuickReference } from './types';

export const alienInvasionQuickReference: AlienQuickReference[] = [
  {
    "scenarioId": "invasion",
    "title": "Invasion — szybka ściąga",
    "setupChecklist": [
      "Wspólny wynik ludzi na 0",
      "Troop Tracker na 20",
      "Rozdaj defensywne projekty",
      "Obcy: 4 oddziały na planszy, 16 w rezerwie, 3 kryształy"
    ],
    "turnChecklist": [
      "Człowiek",
      "Dowódca Obcych",
      "Powtarzaj po każdym człowieku"
    ],
    "victoryChecklist": [
      "Ludzie: 100 OP",
      "Obcy: 20 oddziałów na mapie",
      "Brak punktacji końcowej"
    ]
  },
  {
    "scenarioId": "outbreak",
    "title": "Outbreak — szybka ściąga",
    "setupChecklist": [
      "2 leki w magazynie zamiast kryształów",
      "Wylosuj czerwoną i niebieską misję",
      "Ustaw czas według liczby graczy"
    ],
    "turnChecklist": [
      "Poza rundą 1 dobierz infekcję",
      "Możesz przeorganizować własne kwatery",
      "Na końcu tury rozprzestrzeń zakażenie"
    ],
    "victoryChecklist": [
      "Obie misje ukończone",
      "Mniej zakażonych niż 12/14",
      "Czas nie spadł do 0"
    ]
  },
  {
    "scenarioId": "blackout",
    "title": "Blackout — szybka ściąga",
    "setupChecklist": [
      "Ustaw czas 6/7/8",
      "Przygotuj Vandalism i 10 tokenów"
    ],
    "turnChecklist": [
      "Na końcu tury odkryj Vandalism",
      "Najpierw dokończ blackout, potem dewastuj",
      "Cel zmniejsza czas i daje jedną naprawę"
    ],
    "victoryChecklist": [
      "Czas z 1 na 0",
      "Mniej niż 5 blackoutów",
      "Dostępny kolonista do każdego wymaganego blackout"
    ]
  },
  {
    "scenarioId": "monolith",
    "title": "Monolith — szybka ściąga",
    "setupChecklist": [
      "Tor 15, czas 0",
      "2 karty sabotażu",
      "5 celów z 5 talii"
    ],
    "turnChecklist": [
      "Kolonizacja",
      "Sabotaż",
      "Wahadłowiec"
    ],
    "victoryChecklist": [
      "4 z 5 celów przed wejściem czasu na 15"
    ]
  }
];
